import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../../assests/css/students/Principal/PrincipalGallery.css";

// Replace these image URLs with your real gallery photos.
// Each "page" holds 9 images (3x3 grid), matching the reference design.
const galleryPages = [
  [
    { id: 1, image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS8Y5jLp84XBvdbQ55wxzdNxPHCMqmvQGALLE0h3j1XX0qE4yJWpcjgLLf-&s=10", label: "Meetings" },
    { id: 2, image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQtRcvL_9udNGirTWZKb2aUyutuhNgG8nZ7NnNo5K0LT7_ROkIrMoAZ2rhI&s=10", label: "Convocation" },
    { id: 3, image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSYrPqlfioFbm0K-or7U00-S-9zp0KIijrmKwv22UNDhdKSOg5xljEsVFO1&s=10", label: "Events" },
    { id: 4, image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQkvpoqYldNwdLneaRi4o2lOYBBDTKf4ZaDvospFd8CFtM_krs-45NGSV4&s=10", label: "Events" },
    { id: 5, image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSrPYqbNHLDLXNFvcFgMz3JK47pKgcqicfDcnnwVAfHPfl2Z1Wb-hsanAw4&s=10", label: "Award Ceremonies" },
    { id: 6, image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRlMisTvoloAEYIyh5fA59CRsmzPAyrlAQBV42ZztnKSzSvkiK7eQinpWc&s=10", label: "Student Activities" },
    { id: 7, image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTv8Z0MASV6QO8VIQyh_U0Kpg0CV-rWqUrwaF7JmumdvC0uTT1FsiMc5dY&s=10", label: "Award Ceremonies" },
    { id: 8, image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQahSCVCQemtRNb4x48z8ys_W66C_OBAeTDQrELf4oZigryk0NaLEZTJ0&s=10", label: "Student Activities" },
    { id: 9, image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQKTL3nDYWe9jciBAfyueg6WFrjHSGWiA9Awv5OeRJA7mltbpiC1Y9ifwQ&s=10", label: "Official Visits" },
  ],
  [
    { id: 10, image: "https://i.ytimg.com/vi/WsLs9ISfc-A/mqdefault.jpg", label: "Meetings" },
    { id: 11, image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQjeLfcJNQnxdVYDjbPRYmX1Cs_ksX8R7zvJJxvlMyAEEIeKKNaH4gzQEA&s=10", label: "Convocation" },
    { id: 12, image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSjj-YhY08FXOCULQHiss3gD2X0qdDZF5hbzfRWGNrYPagkxNFVcNmTOK95&s=10", label: "Events" },
    { id: 13, image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQYPlXSCPpyGbNX2rtf-GelTwZ9VvPv8iRGYVbgpQr1P3Ss3mzByGxEU7W2&s=10", label: "Events" },
    { id: 14, image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQtRcvL_9udNGirTWZKb2aUyutuhNgG8nZ7NnNo5K0LT7_ROkIrMoAZ2rhI&s=10", label: "Award Ceremonies" },
    { id: 15, image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQR_5QaerU2UI6dSfG8yxJIyKB3eGteW0zIfWo90rmc6Q&s", label: "Student Activities" },
    { id: 16, image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSugIF_wDgOz09fUcM_9ug5-vd4nJElAOTLcCCuzFnXZQ&s", label: "Award Ceremonies" },
    { id: 17, image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTJCvwdZmqO4lsLPAco2GyBoI3bwOhZFdflWBatjZlkep8YkjcBx5HaGHs&s=10", label: "Student Activities" },
    { id: 18, image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRv9vLEwAEm4mYMFBvA7KSyJroVtAteVswP1STLK_H0dNgqX77R2-5w8iI&s=10", label: "Official Visits" },
  ],
];

const GallerySection = () => {
  const [activePage, setActivePage] = useState(0);

  return (
    <section className="gallery-section">
      <Container>
        <Row>
          <Col xs={12}>
            <h2 className="gallery-heading">Gallery</h2>
          </Col>
        </Row>

        <Row className="g-3 gallery-row">
          {galleryPages[activePage].map((item) => (
            <Col xs={12} sm={6} md={4} key={item.id}>
              <div className="gallery-card">
                <img
                  src={item.image}
                  alt={item.label}
                  className="gallery-image"
                />
                <div className="gallery-overlay">
                  <span className="gallery-label">{item.label}</span>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        {galleryPages.length > 1 && (
          <Row>
            <Col xs={12}>
              <div className="gallery-dots">
                <button
                  className="gallery-arrow"
                  onClick={() =>
                    setActivePage((prev) =>
                      prev === 0 ? galleryPages.length - 1 : prev - 1
                    )
                  }
                  aria-label="Previous page"
                >
                  ‹
                </button>

                {galleryPages.map((_, index) => (
                  <span
                    key={index}
                    className={`gallery-dot ${
                      index === activePage ? "active" : ""
                    }`}
                    onClick={() => setActivePage(index)}
                  />
                ))}

                <button
                  className="gallery-arrow"
                  onClick={() =>
                    setActivePage((prev) =>
                      prev === galleryPages.length - 1 ? 0 : prev + 1
                    )
                  }
                  aria-label="Next page"
                >
                  ›
                </button>
              </div>
            </Col>
          </Row>
        )}
      </Container>
    </section>
  );
};

export default GallerySection;